// const apiUrl = 'http://192.168.0.166:8081/api/v1/';
// const apiUrl = 'http://192.168.0.187:8081/api/v1/';
// const apiUrl = 'http://192.168.0.156:8081/api/v1/';
// const apiUrl = 'http://192.168.1.37:8081/api/v1/';
// const apiUrl = 'http://192.168.255.58:8081/api/v1/';
// const apiUrl = 'http://192.168.1.2:8081/api/v1/';
// const apiUrl = 'http://10.157.204.164:8081/api/v1/';
const apiUrl = 'https://api.thesubscription.in/api/v1/'
// const apiUrl = 'http://api.thesubscription.in:8082/api/v1/'


export default apiUrl
